"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var theme_1 = require("../../../theme");
exports.Wrapper = styled_components_1.default.svg.attrs({
    width: '32',
    height: '32',
    viewBox: '0 0 32 32',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  width: ", ";\n  height: ", ";\n\n  @media ", " {\n    width: ", ";\n    height: ", ";\n  }\n\n  @media ", " {\n    width: ", ";\n    height: ", ";\n  }\n"], ["\n  color: ", ";\n  width: ", ";\n  height: ", ";\n\n  @media ", " {\n    width: ", ";\n    height: ", ";\n  }\n\n  @media ", " {\n    width: ", ";\n    height: ", ";\n  }\n"])), function (_a) {
    var $color = _a.$color;
    return ($color ? theme_1.theme.colors[$color] : 'currentColor');
}, function (_a) {
    var $width = _a.$width;
    return (($width === null || $width === void 0 ? void 0 : $width.small) ? $width.small + 'px' : 'auto');
}, function (_a) {
    var $height = _a.$height;
    return (($height === null || $height === void 0 ? void 0 : $height.small) ? $height.small + 'px' : 'auto');
}, theme_1.theme.breakpoints.medium, function (_a) {
    var $width = _a.$width;
    return (($width === null || $width === void 0 ? void 0 : $width.medium) ? $width.medium + 'px' : 'auto');
}, function (_a) {
    var $height = _a.$height;
    return (($height === null || $height === void 0 ? void 0 : $height.medium) ? $height.medium + 'px' : 'auto');
}, theme_1.theme.breakpoints.large, function (_a) {
    var $width = _a.$width;
    return (($width === null || $width === void 0 ? void 0 : $width.large) ? $width.large + 'px' : 'auto');
}, function (_a) {
    var $height = _a.$height;
    return (($height === null || $height === void 0 ? void 0 : $height.large) ? $height.large + 'px' : 'auto');
});
var templateObject_1;
